<div class="mobile-navbar">
  <div class="wrapper">
    <app-logo [logoImage]="'assets/logo/light/css-logo.svg'" />
  </div>
</div>
